import { Component, Vue } from 'vue-property-decorator'

@Component
export default class luckDialog extends Vue {
    mobile:any = '' // 手机号
    get roomDetail() {
		return this.$store.getters["getRoomDetail/getRoomDetail"];
	}

    close(){
        this.$emit('closePhoneHint',false)
    }

	submitPhone() {
		let url = `//pub${this.domain}/live/tv/liveLuck/supplementMobile`;
        let reg = /^[1][3-9][0-9]{9}$/
        if(!reg.test(this.mobile)){
            this.$toast("请检查输入的手机号码是否正确");
            return false
        }
		this.fetch({
            url: url,
            data:{
                scene_id : this.roomDetail.scene_id,
                mobile : this.mobile
            }
		}).then((data: any) => {
            this.$toast("提交成功，主播将会尽快联系到你");
            this.$store.dispatch("refresh/getPhoneAsync", {
				scene_id: this.roomDetail.scene_id
			});
		});
	}

}
